const getState = (state) => state['features/room-cascade'];
export const getLimitConnections = (state) => getState(state)?.limitConnections;
export const getUsedConnections = (state) => getState(state)?.usedConnections;
export const getRoomCascadeSessions = (state) => getState(state)?.sessions;
export const getTmpSession = (state) => getState(state)?.tmpSession;
export const getRoomCascadeSession = (state, roomId) => {
    if (getState(state).sessions !== undefined) {
        return getState(state).sessions[roomId];
    }
    else {
        return null;
    }
};
export const startCascade = (state, roomId) => {
    const session = getRoomCascadeSession(state, roomId);
    session?.instance?.start();
};
export const stopCascade = (state, roomId) => {
    const session = getRoomCascadeSession(state, roomId);
    session?.instance?.stop();
};
